import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { ShipmentsService } from "src/app/core/services/basicServices/shipments.service";
import { DataService } from "src/app/core/services/data.service";
import { ReportComponent } from "../report/report/report.component";
import { SelectionModel } from "@angular/cdk/collections";

@Component({
  selector: "app-sale-order",
  templateUrl: "./sale-order.component.html",
  styleUrls: ["./sale-order.component.scss"],
})
export class SaleOrderComponent implements OnInit {
  displayedColumns: string[] = [
    "select",
    "salesOrderNumber",
    "salesOrderName",
    "date",
    "address",
    "email",
    "notes",
  ];
  dataSource = new MatTableDataSource<any>();
  @ViewChild("paginator", { static: true }) paginator: MatPaginator;
  modalOptions: NgbModalOptions = {};
  selection = new SelectionModel<any>(true, []);
  tableModel = { search: "", start: 0, limit: 10, sort: "", order: "" };
  modalRef: any;
  total = 0;
  constructor(
    private shipmentService: ShipmentsService,
    private modalService: NgbModal,
    private dataService: DataService,
    public router: Router,
    public Alerts: MatSnackBar
  ) {}

  ngOnInit() {
    // this.dataSource.paginator = this.paginator;
    this.dataTableConfig();
  }

  reset() {
    this.tableModel.search = "";
    this.getList();
  }

  getReportData() {
    const salesOrderNumbers = this.selection.selected.map(
      (order) => order.salesOrderNumber
    );
    let a = { SalesOrderNumber: salesOrderNumbers };
    this.shipmentService.getAllPackingSlips(a).subscribe((res) => {
      if (res) {
        let m = {
          data: res,
          path: "assets/reports/PackingSlip.xml",
        };
        this.dataService.passData(m);
        this.router.navigate(["/packing-slip"]);
      } else {
      }
    });
  }

  openFormModal() {
    debugger;
    console.log(this.selection.selected);
    let m = {
      data: [],
      path: "assets/reports/PackingSlip.xml",
    };
    this.dataService.passData(m);
    this.router.navigate(["/packing-slip"]);
    // this.dataService.setModel(model);
    // this.modalOptions.backdrop = "static";
    // this.modalOptions.keyboard = false;
    // this.modalOptions.size = "lg";
    // this.modalOptions.centered = true;
    // this.modalRef = this.modalService.open(ReportComponent, this.modalOptions);
    // this.modalRef.result
    //   .then((result) => {
    //     if (result) {
    //     }
    //   })
    //   .catch((error) => { });
  }

  dataTableConfig() {
    this.getList();
    // this.dataSource.paginator = this.paginator;
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => this.selection.select(row));
  }

  getList() {
    this.shipmentService
      .getAllSaleOrdersPagination(this.tableModel)
      .subscribe((res) => {
        if (res) {
          console.log(res);
          this.dataSource.data = res.dataList;
          this.total = res.totalCount;
          this.paginator.length = this.total;
        } else {
          this.dataSource.data = [];
        }
      });
  }

  onPaginate(pageEvent: any) {
    if (this.tableModel.limit == pageEvent.pageSize) {
      this.tableModel.limit = pageEvent.pageSize;
      this.tableModel.start = pageEvent.pageIndex * pageEvent.pageSize;
    } else {
      this.tableModel.limit = pageEvent.pageSize;
      this.tableModel.start = 0;
    }
    this.getList();
  }
}
